var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","pill":""}},[_c('UserAvatar',{attrs:{"user":_vm.user.picture,"name":_vm.user.name,"role":_vm.user.role}}),_vm._v(" "+_vm._s(_vm.user.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }